import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-gray-700" style={{ backgroundColor: '#d4edeb' }}>
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Store Info */}
          <div>
            <div className="mb-4">
              <img
                src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/223210cca3eea8c93a672cef2c69acc0.png"
                alt="さかなの木"
                className="h-10 w-auto mb-2"
              />
              <h3 className="text-xl font-bold">さかなの木</h3>
            </div>
            <div className="space-y-2 text-sm text-gray-600">
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>〒146-0091<br />東京都大田区鵜の木2-5-5<br />イーグル鵜の木原田ビル1階G号</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:03-6715-0369" className="hover:text-primary transition-colors cursor-pointer">
                  03-6715-0369
                </a>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5"></i>
                <span>
                  ランチ 11:30-14:00<br />
                  ディナー 17:00-22:00(月-木)<br />
                  ディナー 17:00-23:00(金土)
                </span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-calendar-close-line"></i>
                <span>定休日: 日曜日・不定休</span>
              </p>
            </div>
          </div>

          {/* Site Map */}
          <div>
            <h4 className="text-lg font-bold mb-4">サイトマップ</h4>
            <nav className="grid grid-cols-2 gap-2 text-sm">
              <Link to="/" className="text-gray-600 hover:text-primary transition-colors">
                HOME
              </Link>
              <Link to="/concept" className="text-gray-600 hover:text-primary transition-colors">
                コンセプト
              </Link>
              <Link to="/menu" className="text-gray-600 hover:text-primary transition-colors">
                メニュー
              </Link>
              <Link to="/gallery" className="text-gray-600 hover:text-primary transition-colors">
                ギャラリー
              </Link>
              <Link to="/voice" className="text-gray-600 hover:text-primary transition-colors">
                お客様の声
              </Link>
              <Link to="/contact" className="text-gray-600 hover:text-primary transition-colors">
                お問い合わせ
              </Link>
              <Link to="/access" className="text-gray-600 hover:text-primary transition-colors">
                アクセス
              </Link>
              <Link to="/instagram" className="text-gray-600 hover:text-primary transition-colors">
                Instagram
              </Link>
              <Link to="/privacy" className="text-gray-600 hover:text-primary transition-colors">
                プライバシーポリシー
              </Link>
            </nav>
          </div>

          {/* SNS */}
          <div>
            <h4 className="text-lg font-bold mb-4">SNS</h4>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/sakananoki_unoki/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-gray-700 rounded-full hover:bg-primary transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl text-white"></i>
              </a>
              <a
                href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-[#06C755] rounded-full hover:bg-[#05B04D] transition-colors cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-xl text-white"></i>
              </a>
            </div>
            <p className="mt-4 text-sm text-gray-600">
              最新情報はInstagramで<br />毎日更新中！
            </p>

            {/* 関連サイト */}
            <div className="mt-6">
              <h4 className="text-lg font-bold mb-3">関連サイト</h4>
              <a
                href="https://unoki-sakananoki.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                <span>公式ホームページ</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-gray-300 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <p>&copy; 2026 さかなの木. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-primary transition-colors">
              プライバシーポリシー
            </Link>
            <span>|</span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
